import React, { useState, useEffect } from "react";
import { CModal, CCard, CCardBody, CButton } from "@coreui/react";

const GenerateVideoLinkModal = ({
  visible,
  onClose,
  onGenerate,
  loading,
  successMessage,
  errorMessage,
}) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    setShowSuccess(!!successMessage);
    setShowError(!!errorMessage);
  }, [successMessage, errorMessage]);

  const handleOk = () => {
    setShowSuccess(false);
    setShowError(false);
    onClose();
  };

  return (
    <CModal visible={visible} onClose={onClose} alignment="center">
      <CCard className="m-0">
        <CCardBody>
          {/* Header */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="mb-0 text-primary">Generate Video Upload Link</h5>
            <CButton color="light" className="p-0" onClick={onClose}>
              <span aria-hidden="true">&times;</span>
            </CButton>
          </div>

          {/* Body */}
          {!showSuccess && !showError && (
            <p>
              Are you sure you want to generate a new upload link?
              <br />
              <small className="text-muted">
                (Existing unused link will be replaced.)
              </small>
            </p>
          )}

          {/* Success Message */}
          {showSuccess && (
            <div
              className="text-success"
              style={{ fontSize: "1rem", fontWeight: 600 }}
            >
              {successMessage}
            </div>
          )}

          {/* Error Message */}
          {showError && (
            <div
              className="text-danger"
              style={{ fontSize: "1rem", fontWeight: 600 }}
            >
              {errorMessage}
            </div>
          )}

          {/* Footer Buttons */}
          <div className="d-flex justify-content-end mt-4">
            {!showSuccess ? (
              <>
                <CButton color="secondary" className="me-2" onClick={onClose}>
                  Cancel
                </CButton>

                <CButton
                  color="success"
                  disabled={loading}
                  onClick={onGenerate}
                >
                  {loading ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    "Generate Link"
                  )}
                </CButton>
              </>
            ) : (
              <CButton
                color="primary"
                onClick={() => {
                  setShowSuccess(false);
                  onClose();
                }}
              >
                OK
              </CButton>
            )}
          </div>
        </CCardBody>
      </CCard>
    </CModal>
  );
};

export default GenerateVideoLinkModal;
